import { notificationController, uiGameManager } from '../../../shared/scripts/EntryShared.ts';
import { Scene } from './UISceneTypes.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIOnlineFriendController } from '../../../shared/scripts/ui_friends/UIOnlineFriendController.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { sendDiscordScenePageVisitAnalytic } from './sendDiscordScenePageVisitAnalytic.ts';
export class UISceneController {
    get scene() {
        return this._scene;
    }
    set scene(value) {
        this._scene = value;
    }
    static shouldShowMainSceneOnUserInit() {
        // if the conditions for showing the main page change, update `first-scene-detection.ejs`
        const userState = ClientUserState.userState;
        if (userState == undefined) return false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return true;
        if (userState.isLoggedIn) return true;
        if (!userState.hasZeroCompletedGames()) return true;
        return false;
    }
    static shouldShowLandingPage() {
        return !UISceneController.shouldShowMainSceneOnUserInit();
    }
    loadScene(scene, data) {
        if (this.scene == Scene.Room && scene != Scene.Room && scene != Scene.Game) {
            this.uiManager.room.resetRoom();
        }
        const didChangeScene = this.scene != scene;
        this.scene = scene;
        if (didChangeScene && UIUtilsEjsVariables.isUserOnDiscord) sendDiscordScenePageVisitAnalytic(scene);
        this.hideAllScenes();
        this.toggleSidebarAndMinimalHeaderForLandingPage();
        switch(scene){
            case Scene.Lobby:
                this.loadLobbyScene();
                UISceneController.setWindowHistoryState(scene);
                break;
            case Scene.Room:
                this.loadRoomScene();
                break;
            case Scene.Game:
                this.loadGameScene();
                break;
            case Scene.LandingPage:
                this.loadLandingPageScene();
                UISceneController.setWindowHistoryState(scene);
                break;
            case Scene.MainPage:
                this.loadMainPageScene();
                UISceneController.setWindowHistoryState(scene);
                break;
            case Scene.DiscordLeaderboard:
            case Scene.DiscordStore:
            case Scene.DiscordAbout:
            case Scene.DiscordCareers:
            case Scene.DiscordChampionship25:
            case Scene.DiscordChampionship26:
            case Scene.DiscordCommunity:
            case Scene.DiscordFAQ:
            case Scene.DiscordPrivacyPolicy:
            case Scene.DiscordPatchNotes:
            case Scene.DiscordValues:
            case Scene.DiscordValuesExamples:
            case Scene.DiscordTerms:
            case Scene.DiscordPressKit:
            case Scene.DiscordRefundPolicy:
            case Scene.DiscordMore:
                this.loadDiscordScene(scene, data);
                break;
            case Scene.DiscordProfile:
                void this.loadDiscordProfileScene(data);
                break;
            case Scene.DiscordReplay:
                this.loadDiscordReplayScene(data);
                break;
            case Scene.DiscordGifting:
                this.loadDiscordGiftScene(data);
                break;
        }
    }
    hideAllScenes() {
        var _this_uiManager_discordSceneController;
        this.uiManager.lobby.hide();
        this.uiManager.room.hide();
        this.uiManager.landingPage.hide();
        this.uiManager.homepageSceneContainer.classList.add('hidden');
        this.uiManager.layoutContainer.classList.add('hidden');
        (_this_uiManager_discordSceneController = this.uiManager.discordSceneController) === null || _this_uiManager_discordSceneController === void 0 ? void 0 : _this_uiManager_discordSceneController.hideAllScenes();
    }
    static setWindowHistoryState(scene) {
        if (UISceneController.shouldSetWindowHistoryState(scene)) {
            window.history.replaceState({
                pageScene: scene
            }, document.title, window.location.href);
        }
    }
    static shouldSetWindowHistoryState(scene) {
        if (window.history.state == null) return true;
        if (window.history.state == '') return true;
        if (window.history.state.pageScene != scene) return true;
        return false;
    }
    loadDiscordScene(scene, data) {
        var _this_uiManager_discordSceneController;
        this.setupDiscordSceneLayout();
        (_this_uiManager_discordSceneController = this.uiManager.discordSceneController) === null || _this_uiManager_discordSceneController === void 0 ? void 0 : _this_uiManager_discordSceneController.showScene(scene, data === null || data === void 0 ? void 0 : data.hash, data === null || data === void 0 ? void 0 : data.value);
    }
    loadLobbyScene() {
        this.uiManager.sidebar.activateLobby();
        this.uiManager.layoutContainer.classList.remove('hidden');
        this.uiManager.layoutContentWithAds.classList.remove('hidden');
        this.uiManager.homepageSceneContainer.classList.remove('hidden');
        UISceneController.setHomepageContainersVisibility(false, true);
        this.setAdSpaceVisibility(true);
        void this.uiManager.adController.showLobbyVerticalAds();
        this.uiManager.lobby.show();
        this.uiManager.header.headerProfileController.initLoginButton('lobby_page');
        UIOnlineFriendController.userOnlineAndIdle();
    }
    loadRoomScene() {
        this.uiManager.sidebar.activateLobby();
        this.uiManager.layoutContainer.classList.remove('hidden');
        this.uiManager.layoutContentWithAds.classList.add('hidden');
        this.uiManager.room.show();
        notificationController.removeDisconnectBanners();
        UIOnlineFriendController.userEnteredRoom();
    }
    loadGameScene() {
        this.uiManager.matchmakingController.removePopups();
        this.uiManager.adController.removeLobbyAds();
        notificationController.removeDisconnectBanners();
        this.uiManager.clearDOM();
        uiGameManager.canvasController.buildGame();
        UIOnlineFriendController.userEnteredGame();
    }
    loadLandingPageScene() {
        this.uiManager.sidebar.activatePlay();
        this.uiManager.layoutContainer.classList.remove('hidden');
        this.uiManager.layoutContentWithAds.classList.add('hidden');
        this.uiManager.homepageSceneContainer.classList.add('hidden');
        UISceneController.setHomepageContainersVisibility(false, false);
        this.setAdSpaceVisibility(false);
        this.uiManager.landingPage.show();
    }
    loadMainPageScene() {
        // if the elements that are shown here change, update `first-scene-detection.ejs`
        this.uiManager.sidebar.activatePlay();
        this.uiManager.layoutContainer.classList.remove('hidden');
        this.uiManager.layoutContentWithAds.classList.remove('hidden');
        this.uiManager.homepageSceneContainer.classList.remove('hidden');
        const detailsContainer = document.getElementById('mm-details-container');
        const modeSelectorContainer = document.getElementById('mm-mode-selector-container');
        detailsContainer.classList.add('hidden');
        modeSelectorContainer.classList.remove('hidden');
        UISceneController.setHomepageContainersVisibility(true, false);
        this.setAdSpaceVisibility(true);
        void this.uiManager.adController.showLobbyVerticalAds();
        this.uiManager.header.headerProfileController.initLoginButton('main_page');
    }
    async loadDiscordProfileScene(data) {
        this.setupDiscordSceneLayout();
        const username = data === null || data === void 0 ? void 0 : data.username;
        const discordSceneController = this.uiManager.discordSceneController;
        if (username != (discordSceneController === null || discordSceneController === void 0 ? void 0 : discordSceneController.discordProfileController.profileController.username)) {
            await (discordSceneController === null || discordSceneController === void 0 ? void 0 : discordSceneController.discordProfileController.updatePageContent(username));
        }
        discordSceneController === null || discordSceneController === void 0 ? void 0 : discordSceneController.showScene(Scene.DiscordProfile);
    }
    loadDiscordReplayScene(data) {
        var _this_uiManager_discordSceneController;
        UISceneController.validateDiscordEnvironment();
        if ((data === null || data === void 0 ? void 0 : data.gameId) == undefined) return;
        if ((data === null || data === void 0 ? void 0 : data.playerColor) == undefined) return;
        this.setupDiscordSceneLayout();
        const gameId = data.gameId;
        const playerColor = data.playerColor;
        (_this_uiManager_discordSceneController = this.uiManager.discordSceneController) === null || _this_uiManager_discordSceneController === void 0 ? void 0 : _this_uiManager_discordSceneController.discordReplayController.loadReplay(gameId, playerColor);
    }
    loadDiscordGiftScene(data) {
        this.setupDiscordSceneLayout();
        const discordSceneController = this.uiManager.discordSceneController;
        const giftOverlayController = discordSceneController === null || discordSceneController === void 0 ? void 0 : discordSceneController.discordStoreController.storeController.bodyController.giftOverlayController;
        const recipientUsername = data === null || data === void 0 ? void 0 : data.recipientUsername;
        const shouldRecipientSelectionBeFirstPage = recipientUsername != undefined;
        giftOverlayController === null || giftOverlayController === void 0 ? void 0 : giftOverlayController.reorderPages(shouldRecipientSelectionBeFirstPage);
        giftOverlayController === null || giftOverlayController === void 0 ? void 0 : giftOverlayController.updateRecipient(recipientUsername);
        discordSceneController === null || discordSceneController === void 0 ? void 0 : discordSceneController.showScene(Scene.DiscordGifting);
    }
    static validateDiscordEnvironment() {
        if (UIUtilsEjsVariables.isUserOnDiscord) return;
        throw new Error('Not on Discord Integration Server');
    }
    static setHomepageContainersVisibility(isModeSelectorVisible, isLobbyVisible) {
        const modeSelectorContainer = document.getElementById('homepage-mode-selector-container');
        const lobbyContainer = document.getElementById('homepage-lobby-container');
        modeSelectorContainer === null || modeSelectorContainer === void 0 ? void 0 : modeSelectorContainer.classList.toggle('hidden', !isModeSelectorVisible);
        lobbyContainer === null || lobbyContainer === void 0 ? void 0 : lobbyContainer.classList.toggle('hidden', !isLobbyVisible);
    }
    setAdSpaceVisibility(visible) {
        const adSpace = document.getElementById('web-layout-ad-space');
        adSpace.classList.toggle('hidden', !visible);
        this.uiManager.layoutContentWithAds.classList.toggle('no-ads', !visible);
    }
    setupDiscordSceneLayout() {
        UISceneController.validateDiscordEnvironment();
        this.uiManager.layoutContainer.classList.remove('hidden');
        this.uiManager.layoutContentWithAds.classList.remove('hidden');
        UISceneController.setHomepageContainersVisibility(false, false);
        this.setAdSpaceVisibility(false);
    }
    toggleSidebarAndMinimalHeaderForLandingPage() {
        if (this.scene == Scene.LandingPage) {
            this.uiManager.sidebar.hide();
            this.uiManager.header.hide();
        } else {
            this.uiManager.sidebar.show();
            this.uiManager.header.show();
        }
    }
    constructor(uiManager){
        this.scene = Scene.LandingPage;
        this.uiManager = uiManager;
        this.toggleSidebarAndMinimalHeaderForLandingPage();
        ClientUserState.registerChangeListener(()=>{
            if (this.scene == Scene.LandingPage && UISceneController.shouldShowMainSceneOnUserInit()) {
                this.loadScene(Scene.MainPage);
            }
        });
    }
}
